import React from "react";
import { Button , withStyles} from "@material-ui/core";
import LogoutIcon from "@material-ui/icons/PowerSettingsNew";
import AuthService from "../../auth/AuthService";
import { Home } from "@material-ui/icons";
import appConstants from "../../appConstants";
import history from "../../utilities/history";

// Using hardcoded colors since this page should be independent of the theme
const styles = {
    pageBg: {
        background:'url(../images/403BackgroundLight.png)',
        width:"100%",
        height:"100%",
        display:"flex",
        justifyContent:"space-around",
        boxSizing:"border-box",
        backgroundSize:"cover",
        backgroundRepeat:"no-repeat",
        '& > *':{
            boxSizing:"border-box",
        }
    },
    container:{
        minWidth:320,
        width:"100%",
        display: "flex",
        flexDirection:"column",
        justifyContent:"space-evenly",
        alignItems:"center",
        padding:"0px 8px",
        '@media (max-width: 1024px)': {
            width:"80%",
        }
    },
    pageIconContainer:{
        width:"100%",
        padding:"5% 0px",
        height:"45%",
        display:"flex",
        marginRight:130,
        justifyContent:"space-around"
    },
    pageIcon:{
        width:"40%",
        minWidth: 200,
        background:'url(../images/403IconLight.png)',
        backgroundSize:"contain",
        backgroundRepeat:"no-repeat",
        '&:after':{
            content:"",
            display: "block",
            paddingBottom:"100%"
        }
    },
    messageTitle:{
        height: 72,
        lineHeight: "47px",
        fontSize: 66,
        color: "#077566",
        fontWeight: "bold",
        textAlign: "center",
        '@media (max-width: 480px)': {
            fontSize: 20,
        }
    },
    messageSubTitle : {
        height: 60,
        lineHeight: "47px",
        fontSize: 32,
        color: "#077566",
        fontWeight: "bold",
        textAlign: "center",
        '@media (max-width: 480px)': {
            fontSize: 20,
        }
    },
    messageContainer:{
       marginTop:"5%", 
       display:"flex",
       flexDirection:"column",
       width:"50%",
    },
    messageContent:{
        color: "#666666",
        height:55,
        maxWidth:492,
        fontSize:20,
        fontWeight:600,
        lineHeight:"27px",
        textAlign: "center",
        alignSelf:"center",
        '@media (max-width: 480px)': {
            fontSize: 12,
        }
    },
    button:{
        width:180,
        marginTop:"5%",
        alignSelf:"center",
        backgroundColor:"#037465",
        textTransform:"none",
        height:44,
        color: "#FFFFFF",
        fontSize:16,
    },
    icon:{
        padding:"0px 8px 0px 8px",
        fontSize:22
    },
    actionContainer : {
        display : "flex",
        justifyContent : "center"
    },
    homeButton : {
        marginRight : 16 
    }
}

const AccessDenied = props => {
    const { classes } = props;
    const goToHome = () => {
      sessionStorage.removeItem("activeSettingsModule");
      history.push(appConstants.NAV_URLS.HOME)
    }
    return (
      <div className={classes.pageBg}>
        <div className={classes.container}>
          <div className={classes.messageContainer}>
            <div className={classes.messageTitle}>403</div>
            <div className={classes.messageSubTitle}>Access Forbidden</div>
            <div className={classes.messageContent}>
              It seems you tried to access a page you did not have prior
              authorization for.
            </div>
            <div className={classes.actionContainer}>
              <Button
                variant="contained"
                size="small"
                color="primary"
                classes={{ root: `${classes.button} ${classes.homeButton}` }}
                onClick={goToHome}
              >
                <Home classes={{ root: classes.icon }} />
                Home
              </Button>
              <Button
                variant="contained"
                size="small"
                color="primary"
                classes={{ root: classes.button }}
                onClick={AuthService.logout}
              >
                <LogoutIcon classes={{ root: classes.icon }} />
                Log Out
              </Button>
            </div>
          </div>
          <div className={classes.pageIconContainer}>
            <div className={classes.pageIcon}></div>
          </div>
        </div>
      </div>
    );
}

export default withStyles(styles)(AccessDenied);
